/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "ProductAnalyticsService";
const log: any = LoggerModule.getInstance();

export class ProductAnalyticsService {
  private static instance: ProductAnalyticsService;
  private vapp: VApplication;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ProductAnalyticsService {
    if (!ProductAnalyticsService.instance) {
      ProductAnalyticsService.instance = new ProductAnalyticsService(props);
    }
    return ProductAnalyticsService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //AnalyticsWidget Props
    compProps = await agent.getAnalyticsWidgetProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
